import { Identifiable } from './identifiable';

export class DistributionRequest {
  id: string;
  risks: Array<Identifiable> = [];
  users: Array<Identifiable> = [];
}
